// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3UWCN","search":"Settings_search__1cULP","filter":"Settings_filter__1KUYz"};